<div class="card-body" *ngIf="{linkTransferPreview: linkTransferPreview$ | async, sourceUsers: sourceUsers$ | async, targetCompanies: targetCompanies$ | async} as context">
	<div class="loading" *ngIf="!context.sourceUsers">Loading...</div>
	<ng-container *ngIf="context.sourceUsers">
		<div class="header-bar">
			<div class="users-selection">
				<div class="user-select-lookup">
					<label>Source</label>
					<dx-lookup [dataSource]="sourceSystems" displayExpr="name" valueExpr="id" [(ngModel)]="sourceSystem" (onValueChanged)="onSourceSystemChange($event)"></dx-lookup>
					<i class="far fa-plus-square"></i>
					<dx-lookup [dataSource]="context.sourceUsers" displayExpr="name" valueExpr="id" [(ngModel)]="sourceUserId" (onValueChanged)="onSourceUserChange($event)"></dx-lookup>
				</div>
				<i class="far fa-arrow-right"></i>
				<div class="user-select-lookup">
					<label>Target</label>
					<dx-lookup [dataSource]="targetSystems" displayExpr="name" valueExpr="id" [(ngModel)]="targetSystem" (onValueChanged)="onTargetSystemChange($event)"></dx-lookup>
					<i class="far fa-plus-square"></i>
					<dx-lookup [dataSource]="context.targetCompanies" displayExpr="name" valueExpr="id" [(ngModel)]="targetCompanyId" (onValueChanged)="onAL3CompanyChange($event)"></dx-lookup>
				</div>
			</div>
			<div class="transfer-links-button-container">
				<button *ngIf="context.linkTransferPreview" class="btn btn-sm btn-warning transfer-links-button" [disabled]="context.linkTransferPreview.length === 0" (click)="updatePurchaseOrderCache($event)">Update purchase order cache</button>
				<button *ngIf="context.linkTransferPreview" class="btn btn-sm btn-warning transfer-links-button" [disabled]="context.linkTransferPreview.length === 0" (click)="transferLinks(undefined)">Transfer all of this user's links</button>
			</div>
		</div>
		<div class="preview-container">
			<dx-data-grid *ngIf="context.linkTransferPreview" [dataSource]="context.linkTransferPreview" height="100%">
				<dxo-selection mode="none"></dxo-selection>
				<dxo-filter-row [visible]="true"></dxo-filter-row>

				<dxi-column dataField="id"></dxi-column>
				<dxi-column dataField="description"></dxi-column>
				<dxi-column dataField="fromLinkTemplate"></dxi-column>
				<dxi-column dataField="toLinkTemplate"></dxi-column>
				<!--<dxi-column dataField="numberOfSettings"></dxi-column>
				<dxi-column dataField="numberOfMappings"></dxi-column>
				<dxi-column dataField="numberOfProductSettings"></dxi-column>
				<dxi-column dataField="numberOfLineMutations"></dxi-column>-->

				<dxi-column cellTemplate="actionsCellTemplate" [allowResizing]="false" [fixed]="true" fixedPosition="right" dataType="string" width="100px"></dxi-column>

				<div class="actions-cell" *dxTemplate="let d of 'actionsCellTemplate'">
					<button class="btn btn-sm btn-warning transfer-link-button" (click)="transferLinks([d.data.id])">Transfer link</button>
				</div>
			</dx-data-grid>
			<div *ngIf="!context.linkTransferPreview && !loading" class="select-message">Please select a source and target company</div>
			<div *ngIf="!context.linkTransferPreview && loading" class="select-message">Loading...</div>
		</div>
	</ng-container>
</div>

<json-editor-modal></json-editor-modal>

<a id="linkanchor"></a>
